// eslint-disable-line max-len
/* global gettext */
import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import moment from 'moment';
import { formatDateTime, FORMAT_DATE_WITH_TIMEZONE } from 'utils';

const parseIfMoment = value => (moment.isMoment(value) ? formatDateTime(value, '', FORMAT_DATE_WITH_TIMEZONE) : value);

const SSVDownloadLink = ({ url, params, downloadReportHandler }) => {
  const queryString = Object.keys(params.toJS()).map(
    key => `${encodeURIComponent(key)}=${encodeURIComponent(parseIfMoment(params.toJS()[key]))}`,
  ).join('&');

  return (
    <div className="csv-download-link ssv-link">
      <a
        onClick={downloadReportHandler}
        href={downloadReportHandler ? 'javascript:void(0);' : `${url}?${queryString}`} // eslint-disable-line no-script-url
      >
        {gettext('Download report (; Separated)')}
      </a>
    </div>
  );
};

SSVDownloadLink.propTypes = {
  url: PropTypes.string.isRequired,
  params: ImmutablePropTypes.map.isRequired,
  downloadReportHandler: PropTypes.func,
};
SSVDownloadLink.defaultProps = {
  downloadReportHandler: undefined,
};

export default SSVDownloadLink;
